// extracted by mini-css-extract-plugin
export default {"wrapperClass":"I2BeY9dBUHpIhfMPTIg4"};